import { ref } from "vue";
import { SiteService } from "@/services/SiteService";

/**
 * @composable useHomeMagazines
 * @description Gestisce il caricamento degli articoli del magazine per la Home Page.
 * @returns {{
 *   magazines: import('vue').Ref<Array>,
 *   loadMagazines: Function
 * }}
 */
export function useHomeMagazines() {
  const magazines = ref([]); // → Array<Magazine>: articoli dal feed RSS (al massimo 1 per la home)

  async function loadMagazines() {
    const { data } = await SiteService.getMagazines({ limit: 1 });
    magazines.value = data ?? [];
  }

  return { magazines, loadMagazines };
}